import Button from "components/Button"
import Input from "components/Input"
import Modal from "components/Modal"
import { useState } from "react"
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form"
import { createAppointment } from "services/patient/appointment"
import { addAppointment } from "store/slices/appointmentSlice"



const AddAppointment = ({ show, toggleClose }:any) => {

    const dispatch = useDispatch();
    
    const { register, handleSubmit, formState: {errors} } = useForm()
    const [ err, setErr ] = useState('')
    const [ loading, setLoading ] = useState(false)
    
    const onSubmit = (data:any) => {
        setErr('')
        setLoading(true)
            let appointmentData = {   
            event: data.event,
            location:data.location,
            appointment_start_date_time: data.appointment_start_date_time,
            appointment_end_date_time: data.appointment_end_date_time,
            comment: data.comment    
        }
        if(data.appointment_start_date_time > data.appointment_end_date_time){
            setErr(" appointment end date should be after appointment start date")
            setLoading(false)
        }
        else{
            createAppointment(appointmentData).then(
                res => {
                    setLoading(false)
                    toggleClose()
                    dispatch(addAppointment(res.data.result))
    
                }).catch(err => {
                setLoading(false)
                setErr(err.response.data.error)
            })
        }
    }

    return(
        <Modal show={show} toggleClose={toggleClose} >
        <div className="p-8" >
                    <h4>Set Reminder</h4>

                    {(!!err) && (
                        <div
                        className={`  ${
                            !!err && "bg-secondary bg-opacity-10 text-red "
                        }   w-full text-center p-4 mb-4 rounded-md`}
                        >
                        <p
                            className={` ${
                            !!err && "text-secondary "
                            }   text-xs`}
                        >
                            {err}
                        </p>
                        </div>
                    )}

                    <form onSubmit={handleSubmit(onSubmit)} className="my-8" >
                            <Input 
                                name="event" register={register} 
                                label="Event" 
                                error={errors.value && 'Please enter an appointment tittle '} 
                                options={{required: true}}                            
                            />
                            <Input 
                                name="location" 
                                register={register} 
                                label="Location" error={errors.interpretation && 'Please enter location'} 
                                options={{required: false}}                            
                            />
                            <Input 
                                name="appointment_start_date_time" register={register}
                                type="date" 
                                label="Appointment start date" error={errors.first_day_of_last_circle && 'Please enter begining date of appointment'} 
                                options={{ required: true }}                            
                            />
                            <Input 
                                name="appointment_end_date_time" register={register}
                                type="date" 
                                label="Appointment end date" error={errors.first_day_of_last_circle && 'Please enter end date of appointment'} 
                                options={{ required: true }}                            
                            />
                             <Input 
                                name="comment" register={register} 
                                label="Comment" error={errors.description && 'Please enter any comments'} 
                                options={{ required: false }}                            
                            />
        
                        <Button  title="Add Appointment" loading={loading} />
                    </form>
                </div>
                </Modal>
    )
}

export default AddAppointment
